import { useMemoizedFn } from 'ahooks';
import { Flow } from '@/constants/flow';
import type { BizState } from '@/store/use-biz-store';
import { useBizState } from './use-biz-state';
import { useFidoSkip } from './use-fido-skip';
import { useFlow } from './use-flow';

export const useEnablePasskeyFlow = () => {
  const { supportPassKey, userName, callBack } = useBizState();
  const { getState } = useFidoSkip();
  const { setFlow } = useFlow();

  const doEnablePasskeyFlow = useMemoizedFn((data?: Partial<BizState>) => {
    const lastUserName = data?.userName || userName;
    const lastCallBack = data?.callBack || callBack;
    const lastSkipEnablePasskey = getState(lastUserName);

    if (supportPassKey && !lastSkipEnablePasskey) {
      setFlow(Flow.LOGIN_STEP_ENABLE_PASSKEY);
    } else if (lastCallBack) {
      window.location.href = lastCallBack;
    } else {
      setFlow(Flow.EXCEPTION_SOMETHING_WENT_WRONG);
    }
  });

  return {
    doEnablePasskeyFlow,
  };
};
